import bemCnFast from '@webteam/bem-cn-fast';

import localNames from './index.pcss';

export const bemCn = bemCnFast('wt-radio-button', localNames);
